import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function fetchCaptcha() {
  return request({
    url: '/auth/captcha',
    method: 'get'
  })
}

export function fetchClickCaptcha() {
  return request({ url: '/auth/captcha/click', method: 'get' })
}

export function verifyClickCaptcha(data) {
  return request({ url: '/auth/captcha/click/verify', method: 'post', data })
}
